import { RouteLocationNormalized } from 'vue-router';
import { IRouteMeta } from 'src/core/models/routing';
import useFormsRouteUtils from '../router-utils/forms-route-utils';

export default async (to: RouteLocationNormalized) => {
  const { saveFormAsync } = useFormsRouteUtils();
  const wasSuccessfully = await saveFormAsync();
  (to.meta as IRouteMeta).isRouteCanceled = !wasSuccessfully;

  return wasSuccessfully;
};
